import { GOALTYPES } from '../uitls/constants';
import { MESSAGES } from '../uitls/messages';
import { notifyError, notifyInfo, notify } from '../uitls/notification-helper';
import redirect from '../uitls/redirect';
import userService from '../api/user-service';
import router from '@/router';


const GOAL_TYPE = [
    { text: "Calories Burn", value: "calories" },
    { text: "Time per week", value: "minutes" },
];

const state = {
    goalType: GOAL_TYPE[0].value,
    goal: null,
    goalTypes: GOAL_TYPE,
    current: 0,
    loading: false,
    height: null,
    weight: null,
    age: null,
    weightExistsInBackend: false,
    error: null,
    updateAlert: null,
    updateSuccess: null
};

const mutations = {
    setUpdateAlert(state, alertType) {
        state.updateAlert = alertType
    },
    setUpdateSuccess(state, success) {
        state.success = success;
    },
    setError(state, error) {
        state.error = error;
    },
    changeGoalType(state, goalType) {
        state.goalType = goalType;
        state.goal = null;
    },
    changeGoal(state, goal) {
        state.goal = goal;
    },
    changeCurrent(state, current) {
        state.current = current;
    },
    setUserGoal(state, userInfo) {
        if (userInfo.goalType) {
            state.goalType = userInfo.goalType;
            state.goal = userInfo.goalType == 'minutes' ? userInfo.targetMinutes : userInfo.targetCalories;
            state.current = (userInfo.goalType == 'minutes' ? Math.round(+userInfo.goalsAchieved['seconds'] / 60) : +userInfo.goalsAchieved[userInfo.goalType]) || 0;
        }

        state.height = userInfo.height;
        state.weight = userInfo.weight;
        state.weightExistsInBackend = !!state.weight;
        state.age = userInfo.age;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setHeight(state, height) {
        state.height = height
    },
    setWeight(state, event) {
        let weight = event.target.value;
        weight = (weight.indexOf(".") >= 0) ? (weight.substr(0, weight.indexOf(".")) + weight.substr(weight.indexOf("."), 3)) : weight;
        state.weight = 0;
        state.weight = weight
    },
    setAge(state, event) {
        let age = event.target.value;
        age = (age.indexOf(".") >= 0) ? age.substr(0, age.indexOf(".")) : age;
        state.age = 0;
        state.age = age
    }
};

const getters = {

};

const actions = {
    async setGoal({ commit, dispatch, state }) {
        commit('setLoading', true);
        commit('setError', null);
        try {
            await userService.setGoal({ goalType: state.goalType.toLowerCase(), targetValue: state.goal });
            await dispatch('loadUserDetails', null, { root: true });
        } catch (err) {
            commit('setLoading', false);
            commit('setError', MESSAGES.SET_GOAL_FAILED)
            redirect(err);
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },
    async saveUserDetails({ commit, state }) {
        commit('setLoading', true);
        commit('setError', null);
        try {
            await userService.updateUserDetails({ age: state.age, height: state.height, weight: state.weight });
        }
        catch (err) {
            commit('setLoading', false);
            commit('setError', MESSAGES.SET_DETAILS_FAILED)
            redirect(err);
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },
    async changePassword({ commit }, data) {
        commit('setLoading', true);
        commit('setError', null);
        try {
            let response = await userService.changePassword(data);
            if (response.message === 'success') {
                notify(MESSAGES.PASSWORD_UPDATED);
                commit('passwordChanged', true, { root: true });
                router.push({ name: "workout" });
            } else if (response.message === 'sameOldPassword') {
                commit('setError', MESSAGES.SAME_OLD_PASSWORD);
            } else {
                commit('setError', MESSAGES.INCORRECT_PASSWORD);
            }
        }
        catch (err) {
            commit('setLoading', false);
            commit('setError', MESSAGES.SET_DETAILS_FAILED);
            redirect(err);
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },
    async deleteUser({ commit }, data) {
        commit('setLoading', true);
        commit('setError', null);
        try {
            let response = await userService.deleteUser();
            if (response.data.message === 'success') {
                commit('setUpdateAlert', true);
                commit('setError', MESSAGES.PROFILE_DELETED_FAILED);
                commit('logout', true, { root: true })
                return "success"
            } else {
                return "failure"
            }
        }
        catch (err) {
            commit('setLoading', false);
            commit('setError', MESSAGES.PROFILE_DELETED_FAILED);
            redirect(err);
            throw err;
        } finally {
            commit('setLoading', false);
        }
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}